import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap"; 

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { apiUrl} from'../Config/Config';
import axios from 'axios';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

class List extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      abusivelist:'',
      domainlist:[],
      confirmDelete:'',
    };
    this.deleteConfirm = this.deleteConfirm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentDidMount() {
      var qs = require('qs');
      var admin_id = localStorage.getItem("admin_id");
      var loggedas = localStorage.getItem("loggedas");
      var postobject = {
      activePage: 1,
      search_all: '',
      admin_id: admin_id,
      loggedas: loggedas
      };  

      axios.post(apiUrl+"AbusiveManagement/list",qs.stringify(postobject)).then(res => {
        if(res.data.status === 'success'){
         
            this.setState({  abusivelist: res.data.abusivelist, totalRecord: res.data.records_count}, function() {
            
              this.abusivelist();
            });
  
        }
      }); 
   }

   handlePageChange(pageNumber) {
    // console.log(`active page is ${pageNumber}`);
     this.setState({activePage: pageNumber});

     var qs = require('qs');

     var admin_id = localStorage.getItem("admin_id");
     var loggedas = localStorage.getItem("loggedas");
     var postobject = {
       activePage: pageNumber,
       search_all: this.state.search_all,
       admin_id: admin_id,
       loggedas:loggedas
     };
    //  this.props.getabusivelist(qs.stringify(postobject))
    axios.post(apiUrl+"AbusiveManagement/list",qs.stringify(postobject)).then(res => {
      
      if(res.data.status === 'success'){
          this.setState({  abusivelist: res.data.abusivelist, totalRecord: res.data.records_count}, function() {
            this.abusivelist();
          });

      }
    }); 

   }

   handleInputChange(event) {
   const {name, value} = event.target;      
   this.setState({
     [name]: value
   });
   
 }

 handleFormSubmit = () => {
        
  this.setState({Loading:true});
  var qs = require('qs');
  const formPayload = this.state;
   var admin_id = localStorage.getItem("admin_id");
   var loggedas = localStorage.getItem("loggedas");
  var postObject = {             
    activePage   : 1,
    search_all : formPayload.search_all,
    admin_id: admin_id,
    loggedas: loggedas         
  };
  axios.post(apiUrl+"AbusiveManagement/list",qs.stringify(postObject)).then(res => {
    if(res.data.status === 'success'){
        this.setState({  abusivelist: res.data.abusivelist, totalRecord: res.data.records_count}, function() {
          this.abusivelist();
        });
    }else{
      
        this.setState({  abusivelist: '', totalRecord: 0}, function() {
          this.abusivelist();
        });
    
    }
  }); 
} 



deleteConfirm=(confirmstatus,id)=>{
  if(confirmstatus == 'yes'){
    $('.confirm-action-delete').removeClass('show');
    var qs = require('qs');

    var postObject = {
      admin_id : localStorage.getItem("admin_id"),
      id :this.state.confirmDelete,
    };
    axios.post(apiUrl+"AbusiveManagement/delete",qs.stringify(postObject)).then(res => {
      if(res.data.status === 'success'){       
            window.location.reload(); 
      }
    });
  }else{
    $('.confirm-action-delete').removeClass('show');	
  }
}  
deleteabusive(id){
  this.setState({confirmDelete : id})
  $('.confirm-action-delete-message').html('Are you sure delete the Abusive word?');	
  $('.confirm-action-delete').addClass('show');	
 }
activateabusive(id, status){
  let stat = ''
    if(status == 'Inactive'){
      stat = "A";
    }else{
      stat = "I";
    }
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :id,
          status: stat
        };

      axios.post(apiUrl+"AbusiveManagement/change_status",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){
          window.location.reload(false);
        }
      }); 
}


abusivelist() {
  let catImg = '';
  let preview = '';
    var abusivelist = this.state.abusivelist;
    if (abusivelist != "undefined" && abusivelist != null) {
      console.log(abusivelist);
    
      if (abusivelist.length > 0) {

        if (Object.keys(abusivelist).length > 0) {
          const helperlistDetails = abusivelist.map(
            (abusivelist, Index) => {
              let sno = Index+1;
              

               if(abusivelist.status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }
             
              return (
                <tr key={abusivelist.id}>
      					<td>{sno}</td>
      					<td>{abusivelist.abusive_word}</td>
                
                <td>{status}</td>
                <td className="actiongroup" >
                    
                    
                    <Link to={{ pathname: '/abusiveword-edit/'+abusivelist.id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>
                    {(status == 'Active'?<Link onClick={this.activateabusive.bind(this, abusivelist.id, status)} className="" title="Status"><i className="ft-unlock" aria-hidden="true"></i></Link>:<Link onClick={this.activateabusive.bind(this, abusivelist.id, status)} className="" title="Status"><i className="ft-lock" aria-hidden="true"></i></Link>)}      

                   
                    
                     <Link onClick={this.deleteabusive.bind(this,abusivelist.id)} className="" title="Duplicate"><i class="ft-trash-2" aria-hidden="true"></i></Link>
                    
                  </td>
                </tr>
              );
            }
          );
          return helperlistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="11" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }else {
      return (
        <tr>
          <td colspan="11" className="v-align-nr">
            No Result
          </td>
        </tr>
      );
    }
  }
  


  render() {

    const {domainlist,universitynamelist} = this.state;
	  var current = this;
    var admin_id = localStorage.getItem('admin_id');
   let catImg = '';
  let preview = '';
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="abusiveword" /> 
      <div className="content"> 
        <div className="content-wrapper">
        <div class="content-wrapper-before"></div>
   
         <div className="car-listing-wrap leaa-admin-head card vi-2">
            <div className="success_message"></div>
              <div className="listing-header">
                
                <div className="title">
                  <h3>{this.state.totalRecord>0&&this.state.totalRecord} Abusive Words</h3>
                </div>
               

                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                 <div className="add_button">  
                    <a className="" href='/abusiveword-add'>Add</a>
                </div>
                </div>      
                         
              <div style={{color:"green", fontSize: 30}} className="statusmessage"></div>
            
              <div className="car-listing-row table-avrech">
              <div className="overflow">
                <Table striped bordered hover>
                  <thead>
                  <tr>
                  <th>S.No</th>
			            <th>Abusive Word</th>
                 
                  <th>Status</th>
                  <th style={{width:"100px"}}>Action</th>
                   </tr>
                  </thead>
                  <tbody>{this.abusivelist()}</tbody>
                </Table>
			        	</div>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      <div className="confirm-action-delete">
								<p className="confirm-action-delete-message"></p>
								<a href="javascript://" onClick={this.deleteConfirm.bind(this, "yes",this.state.abus_id)} className="btn">Yes</a>
								<a href="javascript://" onClick={this.deleteConfirm.bind(this, "No")} className="btn">No</a>
								<span class="close-support" onClick={this.deleteConfirm.bind(this, "No")}  >X</span>
				</div>
    </div>
    );
  }
}
export default (withRouter(List));